/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiFabStyle = (): Components<Theme>["MuiFab"] => ({
  styleOverrides: {
    root: {
      width: "4rem",
      height: "4rem",
    },
  },
});
